/**
 * List of popular Google Fonts that should be dynamically loaded
 * Add more fonts to this list as needed
 */
const GOOGLE_FONTS = [
  'Montserrat',
  'Roboto',
  'Lato',
  'Poppins',
  'Raleway',
  'Inter',
  'Nunito',
  'Playfair Display',
  'Merriweather',
  'PT Sans',
  'Ubuntu',
  'Rubik',
  'Work Sans',
  'Source Sans Pro',
  'Oswald',
  'Mukta',
  'Quicksand',
  'Fira Sans',
  'Josefin Sans',
  'Noto Sans'
];

/**
 * Check if a font is a Google Font that needs to be loaded
 */
const isGoogleFont = (fontName: string): boolean => {
  const cleanFontName = fontName.trim().replace(/['"]/g, '');
  return GOOGLE_FONTS.some((googleFont) => cleanFontName.toLowerCase() === googleFont.toLowerCase());
};

/**
 * Load a Google Font dynamically by injecting a link tag
 * @param fontFamily - The font family string (e.g., "Montserrat" or "Montserrat, sans-serif")
 */
export const loadGoogleFont = (fontFamily: string | undefined | null): void => {
  if (!fontFamily || typeof window === 'undefined') {
    return;
  }

  // Extract the first font name from the font-family string
  const firstFont = fontFamily.split(',')[0].trim().replace(/['"]/g, '');

  // Check if it's a known Google Font
  if (!isGoogleFont(firstFont)) {
    return;
  }

  // Check if font is already loaded
  const linkId = `google-font-${firstFont.replace(/\s+/g, '-').toLowerCase()}`;
  if (document.getElementById(linkId)) {
    return; // Font already loaded
  }

  // Create and inject the Google Fonts link
  const link = document.createElement('link');
  link.id = linkId;
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${firstFont.replace(/\s+/g, '+')}:wght@300;400;500;600;700&display=swap`;
  document.head.appendChild(link);
};
